import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// ✅ Helper function to check authentication
// ✅ Helper function to check authentication
const useAuth = () => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");

  console.log("🔍 Checking Auth on Route Navigation:");
  console.log("🔹 Token:", token);
  console.log("🔹 Role:", role);
  console.log("🔹 UserID:", userId);

  // ✅ Ensure localStorage is not empty before returning authentication status
  return { token: Boolean(token), role, userId };
};

// ✅ Route Guard for Alumni
export const AlumniRoute = () => {
  const { token, role } = useAuth();
  return token && role === "alumni" ? <Outlet /> : <Navigate to="/pages/registration" />;
};

// ✅ Route Guard for Students
export const StudentRoute = () => {
  const { token, role } = useAuth();
  return token && role === "student" ? <Outlet /> : <Navigate to="/pages/registration" />;
};